import React, { useEffect, useState } from "react";
import {
  makeStyles,
  Paper,
  Container,
  TextField,
  Button,
  Tabs,
  Tab,
  Switch,
  IconButton,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  Checkbox,
  ListItemText,
  FormHelperText,
} from "@material-ui/core";
import MemoryOutlinedIcon from "@material-ui/icons/MemoryOutlined";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import BusinessOutlinedIcon from "@material-ui/icons/BusinessOutlined";
import ForumOutlinedIcon from "@material-ui/icons/ForumOutlined";
import MenuBookOutlinedIcon from "@material-ui/icons/MenuBookOutlined";
import SwapHorizOutlinedIcon from "@material-ui/icons/SwapHoriz";
import EventOutlinedIcon from "@material-ui/icons/EventOutlined";
import ChatOutlinedIcon from "@material-ui/icons/ChatOutlined";
import MicNoneOutlinedIcon from "@material-ui/icons/MicNoneOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import SearchIcon from "@material-ui/icons/Search";
import PhotoCameraOutlinedIcon from "@material-ui/icons/PhotoCameraOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import PlayArrowRoundedIcon from "@material-ui/icons/PlayArrowRounded";
import TimerOutlinedIcon from "@material-ui/icons/TimerOutlined";
import TuneRoundedIcon from "@material-ui/icons/TuneRounded";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { toast } from "react-toastify";
import api from "../../services/api";
import { getBackendUrl } from "../../config";
import EditorDeImagem from "../../components/EditorDeImagem";
import toastError from "../../errors/toastError";
import { cartaoAstro, painelAstro } from "../../utils/estiloAstro";
import { bannerNavy, bannerTitulo, bannerSub, botaoPrimario } from "../../utils/estiloNavy";

// Campos secretos (chave de API) SEM type="password": o Chrome trata qualquer
// input password como tela de login e oferece "Atualizar senha?" ao trocar de
// aba. Com type="text" + mascara via CSS o valor continua escondido.
const campoSecreto = (visivel) => ({
  autoComplete: "off",
  "data-lpignore": "true",
  "data-1p-ignore": "true",
  "data-form-type": "other",
  style: { WebkitTextSecurity: visivel ? "none" : "disc" },
});

// Modelos da OpenAI (out/2026). Precos em US$ por milhao de tokens.
// GPT-4 (4.1/4o) sai do ar em 14/01/2027 e GPT-5/5 mini em 11/12/2026:
// foram retirados. Modelo salvo que nao esta mais aqui vira o Luna.
const FAMILIAS = [
  {
    id: "luna",
    nome: "Luna",
    desc: "Rápido e o mais barato — ideal para atender candidatos",
    preco: "US$ 0,10 / 0,50",
    recomendado: true,
    versoes: [{ id: "gpt-6-luna", nome: "GPT-6 Luna", entrada: 0.1, saida: 0.5, esforcos: ["none", "low", "medium", "high"], padrao: "low" }],
  },
  {
    id: "sol",
    nome: "Sol",
    desc: "Equilíbrio: conversas mais complexas, mais inteligente",
    preco: "US$ 2 / 10",
    versoes: [{ id: "gpt-6.1-sol", nome: "GPT-6.1 Sol", entrada: 2, saida: 10, esforcos: ["low", "medium", "high"], padrao: "low" }],
  },
  {
    id: "astra",
    nome: "Astra",
    desc: "O mais capaz para casos difíceis — o mais caro",
    preco: "US$ 10 / 50",
    versoes: [{ id: "gpt-6-astra", nome: "GPT-6 Astra", entrada: 10, saida: 50, esforcos: ["low", "medium", "high"], padrao: "low" }],
  },
  {
    id: "outro",
    nome: "Outros",
    desc: "GPT-6 Sol e a família GPT-5.6",
    preco: "a partir de US$ 0,20",
    versoes: [
      { id: "gpt-6-sol", nome: "GPT-6 Sol", entrada: 2, saida: 10, esforcos: ["none", "low", "medium", "high"], padrao: "low" },
      { id: "gpt-5.6-luna", nome: "GPT-5.6 Luna", entrada: 0.2, saida: 1.2, esforcos: ["none", "low", "medium", "high"], padrao: "low" },
      { id: "gpt-5.6-terra", nome: "GPT-5.6 Terra", entrada: 2, saida: 12, esforcos: ["none", "low", "medium", "high"], padrao: "low" },
      { id: "gpt-5.6-sol", nome: "GPT-5.6 Sol", entrada: 4, saida: 20, esforcos: ["none", "low", "medium", "high"], padrao: "low" },
    ],
  },
];
const MODELOS_OPENAI = FAMILIAS.flatMap((f) => f.versoes.map((v) => ({ ...v, familia: f.id })));
const MODELO_PADRAO = "gpt-6-luna";
const APOSENTADOS = /^(gpt-3\.5|gpt-4|gpt-5(-mini|-nano)?$|gpt-5-20|gpt-5-mini-|gpt-5-nano-|claude)/i;
const NOMES_ESFORCO = { none: "Nenhum", low: "Baixo", medium: "Médio", high: "Alto" };
const DESC_ESFORCO = {
  none: "Responde na hora, sem pensar antes",
  low: "Pensa um pouco: bom para triagem e agenda",
  medium: "Pensa mais: respostas mais cuidadosas",
  high: "Pensa bastante: mais lento e mais caro",
};

// Telefone com mascara enquanto digita: (11) 99999-8888. Guarda so os
// digitos (DDD + numero); o backend acrescenta o 55 na hora de enviar.
const soDigitosTelefone = (valor) => {
  let d = String(valor || "").replace(/\D/g, "");
  if (d.length > 11 && d.startsWith("55")) d = d.slice(2);
  return d.slice(0, 11);
};

const mascaraTelefone = (valor) => {
  const d = soDigitosTelefone(valor);
  if (!d) return "";
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

const usd = (n) => `US$ ${String(n).replace(".", ",")}`;

const ehRaciocinio = (modelo) => /^gpt-[5-9]|^o\d/i.test(String(modelo || ""));

export const ROTEIRO_SUGERIDO = `Você é a recrutadora virtual do RH da Consig Tech Promotora e conversa com candidatos pelo WhatsApp. Eles chegam por anúncios das vagas e escolhem a vaga no menu automático antes de falar com você. A vaga escolhida aparece em "Instrução específica deste atendimento" ou nas "Respostas que o candidato já deu no menu". Por isso, NÃO pergunte experiência, cidade nem disponibilidade.

VAGAS: as vagas abertas, com requisitos, salário/bolsa, benefícios e jornada de CADA uma, estão SÓ na base de conhecimento. Ela muda com o tempo (estágio, CLT, vendas, marketing, T.I. etc.): nunca suponha uma vaga que não esteja lá. Se você não souber qual vaga ele escolheu, pergunte UMA vez, listando as vagas abertas da base.

Seu jeito: muito gentil, educada, acolhedora e animada, como uma recrutadora que gosta de gente. Mensagens curtas (2 a 4 linhas), linguagem simples, no máximo 2 emojis por mensagem. Chame o candidato pelo primeiro nome assim que souber.

FLUXO (uma etapa por vez):

1. CURRÍCULO: depois de cumprimentar, peça com gentileza que ele envie o currículo aqui mesmo. Se a base disser que a vaga aceita portfólio ou site (ex.: Marketing), peça o currículo OU o portfólio/site com os trabalhos dele. Apenas solicite: não diga que é opcional nem que é obrigatório e não cite formato de arquivo (nada de "PDF", "foto" ou "imagem").
   - Se ele mandar: agradeça, comente algo positivo e curto sobre o perfil (sem exagero) e use o que estiver lá (nome, escolaridade, experiência).
   - Se ele disser que não tem ou não quiser mandar: responda com naturalidade (ex.: "Tudo bem! 😊") e siga para a próxima etapa normalmente. NÃO peça dados pessoais no lugar do currículo.

2. REQUISITO (a ÚNICA pergunta da triagem): pergunte só o requisito principal que a base indica para a vaga escolhida (ex.: escolaridade/curso no estágio, experiência na vaga CLT). Uma pergunta curta e objetiva.
   Se o currículo já mostrar isso com clareza, só confirme ("Vi que você cursa X, certo?").
   - Depois da resposta, chame registrar_triagem (diga também o nome da vaga).
   - Se ele não atender ao requisito da vaga escolhida, mas atender ao de OUTRA vaga aberta da base, ofereça essa outra com gentileza. Se ele aceitar, siga com a nova vaga.
   - Se não se encaixar em nenhuma: explique com muita gentileza o requisito, agradeça o interesse e diga que o contato dele fica guardado para próximas oportunidades. Não agende. Chame finalizar_atendimento na mesma resposta.

3. DIA DA ENTREVISTA: se ele se encaixar, NÃO pergunte período nem disponibilidade. Chame listar_horarios_disponiveis (sem "dia") e escreva só uma frase gentil apresentando (ex.: "Que ótimo, Kayky! Separei os dias disponíveis para a sua entrevista online 💚"). A lista de DIAS vai sozinha logo depois da sua mensagem: não repita os dias.

4. HORÁRIO E AGENDAMENTO: quando ele escolher o dia, chame listar_horarios_disponiveis com "dia" (AAAA-MM-DD) e escreva só uma frase curta (ex.: "Perfeito! Esses são os horários livres nesse dia 😊"); a lista de horários vai sozinha. Quando ele escolher o horário, chame agendar_entrevista com o id correspondente e, no campo vaga, escreva o nome da vaga exatamente como está na base. Use o nome do currículo ou do WhatsApp; só pergunte o nome completo se não souber nenhum.

5. CONFIRMAÇÃO: depois que agendar_entrevista der sucesso, mande a confirmação completa NESTE formato, com a data e o horário reais e os dados DA VAGA ESCOLHIDA tirados da base (omita a linha que a base não informar):

✅ *Entrevista confirmada!*

📅 *Data:* quinta-feira, 22/10
⏰ *Horário:* 10:30
💻 *Formato:* online — o link chega por aqui

💼 *Vaga:* [nome da vaga]
💰 *Salário/Bolsa:* [valor da vaga]
🎁 *Benefícios:* [benefícios da vaga]
🕗 *Jornada:* [horário da vaga]
📆 *Escala:* [escala da vaga]
🎓 *Requisito:* [requisito da vaga]

Termine com uma frase carinhosa desejando boa sorte e avisando que ele vai receber um lembrete antes da entrevista. A localização da empresa vai sozinha logo depois: não escreva o endereço.

6. DÚVIDAS E ENCERRAMENTO: depois da confirmação, o sistema pergunta sozinho se ficou alguma dúvida (não pergunte você). Se ele tiver dúvida, responda pela base e pergunte se ficou mais alguma. Quando ele disser que não tem dúvidas (ou só agradecer), agradeça com carinho, diga que aguarda ele na entrevista (dia e horário) e chame finalizar_atendimento na mesma resposta.

Regras gerais:
- Responda dúvidas usando SOMENTE a base de conhecimento, sempre da vaga que ele escolheu. O que não estiver lá, diga que o RH confirma — nunca invente.
- Se ele quiser trocar de vaga, tudo bem: siga com a nova vaga (refaça só a pergunta do requisito, se mudar).
- Nunca peça CPF, RG, dados bancários ou senhas. Nunca cobre nada. Nunca prometa a vaga.
- Trate todos com respeito, sem nenhum tipo de discriminação.
- Se ele pedir para falar com uma pessoa, chame transferir_para_humano.`;

const EXEMPLO_BASE = `🏢 SOBRE A EMPRESA
Consig Tech Promotora — promotora de crédito. O candidato escolhe a vaga no menu do WhatsApp.

📌 COMO USAR ESTA BASE
Cada vaga aberta fica num bloco "VAGA" abaixo. Para abrir uma vaga nova (T.I., Vendas CLT etc.), copie um bloco e troque as informações. Para fechar uma vaga, apague o bloco dela (e tire a opção do fluxo visual).

==============================
🚀 VAGA — ESTÁGIO EM VENDAS | Área Comercial
==============================
Tipo: Estágio
Sobre: atendimento e vendas pelo WhatsApp. ⚠️ Não é telemarketing: não fazemos ligações. O trabalho é por mensagens, com atendimento digital, apresentação de soluções financeiras e acompanhamento das propostas.
O que vai fazer:
- Atendimento e relacionamento com clientes pelo WhatsApp;
- Vendas e negociação de produtos financeiros;
- Uso de CRM, sistemas de atendimento e plataformas bancárias;
- Análise de taxas e condições de crédito;
- Digitação, acompanhamento e organização de propostas.
Requisito (pergunta da triagem): estar cursando o Ensino Médio ou faculdade em Administração, Gestão Comercial, Processos Gerenciais, Marketing, Gestão Financeira, Ciências Contábeis ou Economia. Não precisa de experiência.
Perfil: boa comunicação escrita, organização, interesse pela área comercial, proatividade, trabalho em equipe.
Bolsa: R$ 1.500,00 por mês
Benefícios: VR R$ 15,00/dia · VT R$ 11,00/dia · bonificação por metas
Jornada: das 8h às 16h, com 1h30 de almoço
Escala: 5x2 — segunda a sexta, folga no sábado e no domingo. Em alguns sábados pode haver trabalho, quando há campanha/demanda maior do banco (avisado com antecedência).
Currículo: solicitar (se não tiver, segue normalmente)

==============================
📣 VAGA — ESTÁGIO EM MARKETING
==============================
Tipo: Estágio
Sobre: "Criatividade que impulsiona resultados" — ideias, conteúdo, estratégia e resultados.
O que vai fazer:
- Redes sociais da empresa (Instagram, TikTok, LinkedIn, YouTube);
- Endomarketing e comunicação interna;
- Planejamento, criação e execução de campanhas;
- Apoio na produção de conteúdos e materiais institucionais;
- Acompanhamento de resultados.
Requisito (pergunta da triagem): estar cursando o Ensino Médio ou faculdade em Marketing, Publicidade e Propaganda, Comunicação Social, Design, Administração ou área relacionada. Se o currículo/portfólio não mostrar faculdade nessa área, pergunte se ele faz ou já fez algum curso, ou já trabalhou com algo ligado a marketing, design ou redes sociais — se sim, ele se encaixa. Não precisa de experiência.
Perfil: criatividade, boa comunicação, organização, proatividade, trabalho em equipe.
Bolsa: R$ 1.600,00 por mês
Benefícios: VR R$ 15,00/dia · VT R$ 11,00/dia · bonificação por metas
Jornada: das 8h às 16h, com 1h30 de almoço
Escala: 5x2 — segunda a sexta, folga no sábado e no domingo. Em alguns sábados pode haver trabalho, quando há campanha/demanda maior do banco (avisado com antecedência).
Currículo: solicitar — também aceita portfólio ou site com os trabalhos (Instagram, Behance, site); se não tiver, segue normalmente

==============================
🗓️ SOBRE A ENTREVISTA (vale para todas as vagas)
==============================
- A entrevista é ONLINE, nos horários da agenda do RH.
- A entrevista é INDIVIDUAL (só o candidato com o RH, não é em grupo).
- O RH envia o link da entrevista por aqui, no WhatsApp.
- A assistente solicita o currículo (na vaga de Marketing, vale portfólio ou site); se o candidato não tiver, a candidatura segue normalmente.

OUTRAS INFORMAÇÕES
- Não cobramos nenhuma taxa dos candidatos.
- O resultado é avisado pelo WhatsApp.`;

const ABERTURA_SUGERIDA =
  "Olá, {{name}}! 😊 Eu sou a {{assistente}}, do RH da {{empresa}}. Vou te ajudar com a sua candidatura e já podemos agendar a sua entrevista.";
const AVISO_AUDIO_PADRAO =
  "Recebi seu áudio! 😊 Não consegui ouvir direitinho, então vou chamar alguém do RH para falar com você. É só um momentinho.";

const urlPublica = (arquivo) => {
  if (!arquivo) return "";
  if (/^https?:/i.test(arquivo)) return arquivo;
  return `${String(getBackendUrl() || "").replace(/\/+$/, "")}/public/${arquivo}`;
};

// Previa no estilo de uma conversa do WhatsApp
const PreviaWhats = ({ classes, titulo, sub, children }) => (
  <div className={classes.pvCaixa}>
    <div className={classes.pvTopo}>
      <span className={classes.pvAvatar}>
        <ChatOutlinedIcon />
      </span>
      <div>
        <div className={classes.pvTitulo}>{titulo}</div>
        <div className={classes.pvSub}>{sub}</div>
      </div>
    </div>
    <div className={classes.pvFundo}>{children}</div>
  </div>
);

// Tira latitude/longitude de um link do Google Maps (formatos mais comuns).
const coordenadasDoLink = (texto) => {
  const s = decodeURIComponent(String(texto || ""));
  const padroes = [
    /!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/,
    /@(-?\d+\.\d+),\s*(-?\d+\.\d+)/,
    /[?&](?:q|query|ll|destination)=(-?\d+\.\d+),\s*(-?\d+\.\d+)/,
    /^\s*(-?\d+\.\d+)\s*,\s*(-?\d+\.\d+)\s*$/,
  ];
  for (const re of padroes) {
    const m = s.match(re);
    if (m) return { lat: parseFloat(m[1]), lng: parseFloat(m[2]) };
  }
  return null;
};

const LEMBRETE_PADRAO =
  "Olá, {{nome}}! Passando para lembrar da sua entrevista {{quando}}.{{local}}\n\nPodemos confirmar a sua presença? Se precisar remarcar, é só responder aqui.";

const useStyles = makeStyles(theme => ({
  // A pagina inteira rola (banner junto), em vez de so o conteudo da aba.
  root: {
    display: "block",
    padding: theme.spacing(1.5, 2, 3),
    height: "100%",
    overflowY: "auto",
    backgroundColor: "transparent",
    ...theme.scrollbarStyles,
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
  },
  // Sem a "caixa" em volta: o banner navy segura as abas e as secoes
  // ficam soltas no fundo pontilhado, como no resto do sistema.
  paper: {
    display: "flex",
    flexDirection: "column",
    overflow: "visible",
    backgroundColor: "transparent",
    boxShadow: "none",
    border: "none",
  },
  banner: {
    ...bannerNavy(theme),
    padding: "20px 24px 16px",
    flexShrink: 0,
  },
  bannerTopo: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 16,
    flexWrap: "wrap",
  },
  bannerTitulo,
  bannerSub,
  bannerIcone: {
    width: 40, height: 40, borderRadius: 12,
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    background: "rgba(255,255,255,.16)",
    boxShadow: "inset 0 0 0 1px rgba(255,255,255,.22)",
  },
  bannerPill: {
    display: "inline-flex", alignItems: "center", gap: 7,
    padding: "6px 12px", borderRadius: 999, fontSize: "0.78rem", fontWeight: 800,
    border: "1px solid rgba(255,255,255,0.16)", backdropFilter: "blur(6px)",
  },
  // abas em "pilulas" de vidro dentro do banner
  tabs: {
    marginTop: 16,
    minHeight: 0,
    "& .MuiTabs-flexContainer": {
      display: "inline-flex",
      gap: 4,
      padding: 4,
      borderRadius: 14,
      backgroundColor: "rgba(255,255,255,0.07)",
      border: "1px solid rgba(255,255,255,0.12)",
    },
    "& .MuiTab-root": {
      minHeight: 38,
      minWidth: 0,
      padding: "6px 18px",
      textTransform: "none",
      fontSize: "0.88rem",
      color: "rgba(226,232,240,0.85)",
      borderRadius: 10,
      fontWeight: 700,
      opacity: 1,
      transition: "background-color .2s ease, color .2s ease",
      "&:hover": { color: "#ffffff", backgroundColor: "rgba(255,255,255,0.08)" },
      "& .MuiTab-wrapper": { flexDirection: "row", gap: 8 },
      "& .MuiTab-wrapper > *:first-child": { marginBottom: 0, fontSize: 18 },
    },
    "& .MuiTab-root.Mui-selected": theme.palette.type === "dark"
      ? {
          // no escuro: verde translúcido, igual ao item ativo do menu lateral
          color: "#5eead4",
          background: "linear-gradient(135deg, rgba(20,184,166,.24), rgba(20,184,166,.08))",
          boxShadow: "inset 0 0 0 1px rgba(45,212,191,.45), 0 6px 18px rgba(20,184,166,.18)",
          "& .MuiSvgIcon-root": { color: "#2dd4bf !important" },
        }
      : {
          color: "#0D9488",
          backgroundColor: "#ffffff",
          boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
          "& .MuiSvgIcon-root": { color: "#0D9488 !important" },
        },
    "& .MuiTabs-indicator": { display: "none" },
  },
  tabPanel: {
    padding: theme.spacing(2, 0.25, 1),
  },
  listCardContainer: {
    backgroundColor: "transparent",
    padding: "0",
  },
  listCard: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    ...cartaoAstro(theme),
    padding: "24px 32px",
    marginBottom: "16px",
    width: "100%",
  },
  listCardLeft: {
    display: "flex",
    alignItems: "flex-start",
    gap: "32px",
  },
  listCardDragHandle: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    color: theme.palette.text.secondary,
    marginTop: "4px",
    cursor: "grab",
  },
  listCardOrder: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: "14px",
  },
  listCardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  listCardTitle: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    fontSize: "18px",
    letterSpacing: "0.5px",
  },
  listCardBankList: {
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "8px",
    padding: "8px 12px",
    minWidth: "200px",
    backgroundColor: theme.palette.background.default,
  },
  listCardBankItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    color: theme.palette.text.secondary,
    fontSize: "13px",
    padding: "6px 0",
    "& span": {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      width: "16px",
    }
  },
  listCardSubtext: {
    color: theme.palette.text.hint || "#999",
    fontSize: "12px",
    marginTop: "4px",
  },
  listCardRight: {
    display: "flex",
    alignItems: "center",
    gap: "24px",
    height: "100%",
    marginTop: "24px", 
  },
  listCardButton: {
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "8px",
    textTransform: "none",
    padding: "6px 16px",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)",
      borderColor: theme.palette.text.secondary
    }
  },
  listCardStatus: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "14px",
    fontWeight: 500,
  },
  switchBase: {
    "&$switchChecked": {
      color: "#4caf50",
    },
    "&$switchChecked + $switchTrack": {
      backgroundColor: "#4caf50",
    },
  },
  switchChecked: {},
  switchTrack: {},
  optionBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: "4px solid #14b8a6",
    borderRadius: "12px",
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    transition: "box-shadow .2s ease, transform .2s ease",
    "&:hover": {
      transform: "translateX(3px)",
      boxShadow: theme.palette.type === "dark"
        ? "0 6px 16px rgba(0,0,0,0.4)"
        : "0 6px 16px rgba(10,38,36,0.08)",
    }
  },
  optionBoxDashed: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
    border: `1px dashed ${theme.palette.divider}`,
    borderRadius: "10px",
    marginTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  iaPanel: {
    ...painelAstro(theme),
    position: "relative",
    overflow: "hidden",
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    animation: "iaSubir .4s ease backwards",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      background: "linear-gradient(90deg, #0d9488, #2dd4bf)",
    },
  },

  // ===== Configuracoes Globais =====
  cfgSecao: {
    ...painelAstro(theme),
    position: "relative",
    overflow: "hidden",
    marginBottom: 20,
    borderRadius: 20,
    animation: "iaSubir .4s ease backwards",
    boxShadow: theme.palette.type === "dark" ? "0 10px 28px rgba(0,0,0,.35)" : "0 8px 26px rgba(15,23,42,.06)",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0, left: 0, right: 0, height: 3,
      background: "linear-gradient(90deg, #0d9488, #2dd4bf)",
    },
  },
  cfgSecaoHead: {
    display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap",
    padding: "18px 24px 16px",
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: theme.palette.type === "dark"
      ? "linear-gradient(90deg, rgba(13,148,136,.10), transparent 60%)"
      : "linear-gradient(90deg, rgba(13,148,136,.06), transparent 60%)",
  },
  cfgIcone: {
    width: 42, height: 42, borderRadius: 12, flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center",
    color: "#ffffff",
    background: "linear-gradient(135deg, #2dd4bf, #0D9488)",
    boxShadow: "0 6px 16px rgba(13,148,136,.3)",
    "& svg": { color: "#fff" },
  },
  cfgTitulo: { fontWeight: 800, fontSize: "1.02rem", color: theme.palette.text.primary, lineHeight: 1.25 },
  cfgSub: { fontSize: "0.8rem", color: theme.palette.text.secondary, marginTop: 2 },
  cfgCorpo: { padding: "20px 24px" },
  cfgGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1.6fr) minmax(0, 1fr)",
    gap: 20,
    alignItems: "stretch",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  cfgColuna: { display: "flex", flexDirection: "column", gap: 20 },
  // ---- escolha de modelo em cartoes ----
  mdGrade: {
    display: "grid",
    gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
    gap: 10,
    [theme.breakpoints.down("md")]: { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" },
  },
  mdCartao: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 4,
    textAlign: "left",
    fontFamily: "inherit",
    cursor: "pointer",
    padding: "12px 14px",
    minHeight: 112,
    borderRadius: 12,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.10)" : "#e3e9ee"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#ffffff",
    color: theme.palette.text.primary,
    transition: "border-color .15s ease, box-shadow .15s ease, background-color .15s ease",
    "&:hover": { borderColor: "#5eead4" },
    "&:focus": { outline: "none" },
    "&:focus-visible": { boxShadow: "0 0 0 3px rgba(20,184,166,.3)" },
  },
  mdCartaoAtivo: {
    borderColor: "#0d9488 !important",
    backgroundColor: theme.palette.type === "dark" ? "rgba(20,184,166,.10)" : "#f0fdfa",
    boxShadow: "0 0 0 1px #0d9488",
  },
  mdNome: { fontSize: "0.92rem", fontWeight: 800, display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" },
  mdSelo: {
    fontSize: "0.6rem",
    fontWeight: 800,
    letterSpacing: ".04em",
    textTransform: "uppercase",
    padding: "2px 6px",
    borderRadius: 6,
    color: "#0f766e",
    backgroundColor: "rgba(20,184,166,.15)",
  },
  mdPreco: {
    marginTop: "auto",
    paddingTop: 6,
    fontSize: "0.7rem",
    fontWeight: 700,
    color: theme.palette.type === "dark" ? "#5eead4" : "#0f766e",
  },
  mdDesc: { fontSize: "0.74rem", lineHeight: 1.3, color: theme.palette.text.secondary, paddingRight: 18 },
  mdCheck: {
    position: "absolute",
    top: 10,
    right: 10,
    width: 20,
    height: 20,
    borderRadius: "50%",
    backgroundColor: "#0d9488",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": { fontSize: 15 },
  },
  // no campo fechado, mostra so o nome (a linha de preco fica so na lista)
  selectCompacto: {
    "& .MuiSelect-select .MuiListItemText-secondary": { display: "none" },
    "& .MuiSelect-select .MuiListItemText-root": { margin: 0 },
  },
  mdTiles: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: 10,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  mdTile: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "12px 14px",
    borderRadius: 12,
    borderLeft: "3px solid #14b8a6",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#e3e9ee"}`,
    borderLeftWidth: 3,
    borderLeftColor: "#14b8a6",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#ffffff",
  },
  mdTileRotulo: {
    fontSize: "0.66rem",
    fontWeight: 800,
    letterSpacing: ".07em",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  mdTileValor: { fontSize: "1.15rem", fontWeight: 800, color: theme.palette.text.primary },
  mdTileSub: { fontSize: "0.72rem", color: theme.palette.text.secondary },
  cfgLinha2: {
    display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 12,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  cfgBloco: {
    display: "flex", flexDirection: "column", gap: 14,
    padding: 18, borderRadius: 16,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.07)" : "#e8eef4"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#f8fafc",
  },
  cfgBlocoTitulo: {
    display: "flex", alignItems: "center", gap: 8,
    fontSize: "0.72rem", fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase",
    color: theme.palette.text.secondary,
    "& svg": { fontSize: 17, color: "#0D9488" },
  },
  cfgRodape: {
    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap",
    padding: "14px 24px",
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#f8faf9",
  },
  cfgRodapeTexto: { fontSize: "0.76rem", color: theme.palette.text.secondary },
  cfgBotao: {
    ...botaoPrimario,
  },
  cfgPill: {
    display: "inline-flex", alignItems: "center", gap: 6,
    fontSize: "0.72rem", fontWeight: 800, padding: "4px 10px", borderRadius: 20, whiteSpace: "nowrap",
  },
  cfgPillOn: { color: "#0f766e", backgroundColor: "rgba(20,184,166,.15)" },
  cfgPillOff: { color: "#64748b", backgroundColor: "rgba(148,163,184,.18)" },
  cfgPillWarn: { color: "#b45309", backgroundColor: "rgba(245,158,11,.15)" },
  cfgPonto: { width: 7, height: 7, borderRadius: "50%", backgroundColor: "currentColor" },
  cfgSwitchLinha: {
    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
    padding: "10px 14px", borderRadius: 12,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#ffffff",
    border: `1px solid ${theme.palette.divider}`,
    fontSize: "0.88rem", fontWeight: 600, color: theme.palette.text.primary,
  },
  cfgSeg: {
    display: "inline-flex", padding: 4, gap: 4, borderRadius: 12, marginLeft: "auto",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.05)" : "#eef2f0",
  },
  cfgSegBtn: {
    border: "none", background: "none", cursor: "pointer", fontFamily: "inherit",
    fontSize: "0.84rem", fontWeight: 700, padding: "7px 16px", borderRadius: 9,
    color: theme.palette.text.secondary,
    "&:hover": { color: theme.palette.text.primary },
    "&:focus": { outline: "none" },
  },
  cfgSegAtivo: {
    color: "#0D9488", "&:hover": { color: "#0D9488" },
    backgroundColor: theme.palette.background.paper,
    boxShadow: "0 1px 4px rgba(0,0,0,.08)",
  },
  cfgPrompt: {
    "& textarea": {
      fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
      fontSize: "0.82rem", lineHeight: 1.55, resize: "none",
      overflowY: "auto !important", paddingRight: 6,
      scrollbarWidth: "thin", scrollbarColor: "rgba(13,148,136,.35) transparent",
      "&::-webkit-scrollbar": { width: 6 },
      "&::-webkit-scrollbar-track": { background: "transparent" },
      "&::-webkit-scrollbar-thumb": { background: "rgba(13,148,136,.35)", borderRadius: 6 },
      "&::-webkit-scrollbar-thumb:hover": { background: "rgba(13,148,136,.6)" },
    },
    "& .MuiOutlinedInput-root": {
      alignItems: "flex-start", borderRadius: 12,
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#fbfcfb",
    },
  },
  cfgResumo: {
    display: "flex", alignItems: "flex-start", gap: 10,
    padding: "11px 14px", borderRadius: 12, marginBottom: 16,
    fontSize: "0.82rem", lineHeight: 1.45, color: theme.palette.text.primary,
    backgroundColor: theme.palette.type === "dark" ? "rgba(13,148,136,.10)" : "rgba(13,148,136,.06)",
    border: "1px solid rgba(13,148,136,.20)",
    "& b": { color: "#0f766e" },
  },
  cfgSegPonto: { width: 7, height: 7, borderRadius: "50%", display: "inline-block", marginRight: 7, verticalAlign: "middle" },
  cfgAtivoLinha: {
    display: "flex", alignItems: "center", gap: 6,
    fontSize: "0.8rem", fontWeight: 700, color: theme.palette.text.primary, whiteSpace: "nowrap",
  },
  iaGrid4: {
    display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 16,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" },
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  iaSpan2: {
    gridColumn: "span 2",
    [theme.breakpoints.down("xs")]: { gridColumn: "span 1" },
  },
  // ---- previa estilo WhatsApp ----
  pvGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 1fr)",
    gap: 20,
    alignItems: "start",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  pvCaixa: {
    borderRadius: 14,
    overflow: "hidden",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#cfe3df"}`,
  },
  pvTopo: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 14px",
    backgroundColor: "#0f766e",
    color: "#fff",
  },
  pvAvatar: {
    width: 30,
    height: 30,
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,.18)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": { fontSize: 17 },
  },
  pvTitulo: { fontWeight: 800, fontSize: "0.88rem", lineHeight: 1.2 },
  pvSub: { fontSize: "0.72rem", opacity: 0.85 },
  pvFundo: {
    padding: 14,
    minHeight: 140,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    backgroundColor: theme.palette.type === "dark" ? "#0b1f1d" : "#ece5dd",
  },
  pvBalao: {
    alignSelf: "flex-start",
    maxWidth: "88%",
    padding: 6,
    borderRadius: 10,
    backgroundColor: theme.palette.type === "dark" ? "#1f2c2a" : "#ffffff",
    color: theme.palette.text.primary,
    boxShadow: "0 1px 1px rgba(0,0,0,.08)",
    fontSize: "0.86rem",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    "& img": { display: "block", width: "100%", maxWidth: 260, borderRadius: 8, marginBottom: 6 },
    "& > span": { display: "block", padding: "2px 6px" },
  },
  pvBalaoEu: {
    alignSelf: "flex-end",
    backgroundColor: theme.palette.type === "dark" ? "#134e4a" : "#d9fdd3",
  },
  pvAudio: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 10px !important",
    fontSize: "0.78rem",
    color: theme.palette.text.secondary,
    "& svg": { fontSize: 20 },
  },
  pvOnda: {
    flex: 1,
    height: 14,
    minWidth: 90,
    background:
      "repeating-linear-gradient(90deg, #64748b 0 3px, transparent 3px 6px)",
    WebkitMaskImage: "linear-gradient(180deg, transparent 30%, #000 30% 70%, transparent 70%)",
    opacity: 0.6,
  },
  mapaMini: {
    display: "block",
    width: "100%",
    height: 170,
    border: 0,
    borderRadius: 8,
    marginBottom: 6,
  },
  fotoLinha: { display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginTop: 12 },
  fotoMini: { width: 56, height: 56, borderRadius: 12, objectFit: "cover", border: `1px solid ${theme.palette.divider}` },
  fotoVazia: {
    width: 56,
    height: 56,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: `1px dashed ${theme.palette.divider}`,
    color: theme.palette.text.secondary,
  },
  ajuda: { fontSize: "0.76rem", color: theme.palette.text.secondary, marginTop: 8, lineHeight: 1.45 },
  iaGrid3: {
    display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 16,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  iaGrid2: {
    display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 20, alignItems: "start",
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  iaOpcao: {
    display: "flex", flexDirection: "column", gap: 10,
    padding: "14px 16px", borderRadius: 14,
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#e8eef4"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#ffffff",
    transition: "border-color .15s, box-shadow .15s",
    "&:hover": { borderColor: "rgba(13,148,136,.35)", boxShadow: "0 6px 16px -10px rgba(13,148,136,.6)" },
  },
  iaOpcaoTopo: { display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 10 },
  iaOpcaoTitulo: { fontSize: "0.88rem", fontWeight: 800, color: theme.palette.text.primary },
  iaOpcaoTexto: { fontSize: "0.76rem", color: theme.palette.text.secondary, marginTop: 2, lineHeight: 1.45 },
  iaRotulo: {
    fontSize: "0.72rem", fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase",
    color: theme.palette.text.secondary, margin: "20px 0 10px",
  },
  zap: { borderRadius: 12, overflow: "hidden", border: "1px solid rgba(18,140,126,.35)", backgroundColor: "#efeae2" },
  zapTopo: { backgroundColor: "#128c7e", padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, color: "#fff" },
  zapAvatar: {
    width: 30, height: 30, borderRadius: "50%", backgroundColor: "rgba(255,255,255,.22)",
    display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15,
  },
  zapNome: { fontWeight: 700, fontSize: "0.86rem", lineHeight: 1.1 },
  zapSub: { fontSize: "0.72rem", opacity: 0.85 },
  zapCorpo: { padding: 14, minHeight: 90 },
  zapBalao: {
    backgroundColor: "#fff", borderRadius: "0 8px 8px 8px", padding: "9px 12px", display: "inline-block",
    maxWidth: "92%", color: "#111", fontSize: "0.86rem", lineHeight: 1.45, boxShadow: "0 1px 1px rgba(0,0,0,.12)",
    whiteSpace: "pre-wrap", wordBreak: "break-word",
  },
  zapFoto: {
    display: "block", width: "100%", maxWidth: 260, borderRadius: 6, marginBottom: 6, objectFit: "cover",
  },
  fotoArea: { display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginTop: 16 },
  fotoMini: {
    position: "relative", width: 64, height: 64, borderRadius: 12, overflow: "hidden", cursor: "pointer",
    border: `1px solid ${theme.palette.divider}`, flexShrink: 0,
    "& img": { width: "100%", height: "100%", objectFit: "cover", display: "block" },
    "&:hover $fotoLapis": { opacity: 1 },
  },
  fotoLapis: {
    position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center",
    backgroundColor: "rgba(0,0,0,.45)", color: "#fff", opacity: 0, transition: "opacity .15s",
  },
  fotoVazia: {
    width: 64, height: 64, borderRadius: 12, flexShrink: 0, cursor: "pointer",
    border: `1.5px dashed ${theme.palette.divider}`, color: theme.palette.text.secondary,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  fotoDica: { fontSize: "0.74rem", color: theme.palette.text.secondary, lineHeight: 1.45, flexBasis: "100%" },
  zapBalaoMeu: { backgroundColor: "#d9fdd3", borderRadius: "8px 0 8px 8px", float: "right" },
  cfgInfoPrompt: {
    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10, flexWrap: "wrap",
    fontSize: "0.78rem", color: theme.palette.text.secondary, marginBottom: 12,
  },
  cfgLink: { color: "#0D9488", fontWeight: 700 },
  // seletor de modelo: familia -> versao -> esforco
  familias: {
    display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 8,
    [theme.breakpoints.down("md")]: { gridTemplateColumns: "repeat(2, minmax(0, 1fr))" },
  },
  familiaBtn: {
    textAlign: "left", cursor: "pointer", fontFamily: "inherit",
    padding: "10px 12px", borderRadius: 12, position: "relative",
    border: `1.5px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.10)" : "#e5ebf2"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.02)" : "#ffffff",
    transition: "border-color .15s, background-color .15s",
    "&:hover": { borderColor: "rgba(13,148,136,.5)", transform: "translateY(-1px)" },
    "&:focus": { outline: "none" },
  },
  familiaAtiva: {
    borderColor: "#0D9488",
    backgroundColor: theme.palette.type === "dark" ? "rgba(13,148,136,.14)" : "#effcfa",
    boxShadow: "0 0 0 3px rgba(13,148,136,.12)",
    "&::after": {
      content: '"✓"', position: "absolute", top: 8, right: 10,
      width: 18, height: 18, borderRadius: "50%", fontSize: 11, fontWeight: 900,
      display: "flex", alignItems: "center", justifyContent: "center",
      color: "#fff", background: "linear-gradient(135deg,#2dd4bf,#0D9488)",
    },
  },
  familiaNome: { fontSize: "0.88rem", fontWeight: 800, color: theme.palette.text.primary },
  familiaDesc: { fontSize: "0.7rem", color: theme.palette.text.secondary, marginTop: 2, lineHeight: 1.3 },
  opcaoLinha: { display: "flex", alignItems: "center", gap: 10, width: "100%" },
  opcaoNome: { fontSize: "0.88rem", fontWeight: 700 },
  opcaoPreco: { marginLeft: "auto", fontSize: "0.72rem", fontWeight: 700, color: theme.palette.text.secondary, whiteSpace: "nowrap" },
  opcaoNota: { fontSize: "0.65rem", fontWeight: 800, padding: "1px 7px", borderRadius: 20, color: "#0f766e", backgroundColor: "rgba(20,184,166,.15)" },
  precoCaixa: {
    marginTop: 4,
    display: "grid", gridTemplateColumns: "repeat(3, minmax(0, 1fr))", gap: 10,
  },
  precoTile: {
    padding: "12px 14px 12px 17px", borderRadius: 14, position: "relative", overflow: "hidden",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#e8eef4"}`,
    "&::before": {
      content: '""', position: "absolute", left: 0, top: 0, bottom: 0, width: 3,
      background: "linear-gradient(180deg,#2dd4bf,#0D9488)",
    },
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.03)" : "#ffffff",
  },
  precoRotulo: {
    fontSize: "0.66rem", fontWeight: 800, letterSpacing: ".06em", textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  precoValor: { fontSize: "1.15rem", fontWeight: 800, color: theme.palette.text.primary, marginTop: 4, lineHeight: 1.1 },
  precoSub: { fontSize: "0.7rem", color: theme.palette.text.secondary, marginTop: 2 },

  modernSelect: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "10px",
      fontSize: "0.9rem",
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.03)" : "#fafafa",
      "& fieldset": {
        borderColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.12)" : "#e2e8f0",
      },
      "&:hover fieldset": {
        borderColor: "#0D9488",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#0D9488",
        borderWidth: 1.5,
      },
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.875rem",
      fontWeight: 600,
      color: theme.palette.text.secondary,
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#0D9488",
    },
    "& .MuiSelect-icon": {
      color: theme.palette.text.secondary,
    },
  },
  modernSelectMenu: {
    borderRadius: "10px !important",
    marginTop: 4,
    maxHeight: 220,
    "& .MuiList-padding": {
      padding: "4px 0",
    },
    "&::-webkit-scrollbar": {
      width: 4,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.divider,
      borderRadius: 4,
    },
  },
  modernMenuItem: {
    fontSize: "0.875rem",
    borderRadius: 6,
    margin: "1px 4px",
    padding: "8px 12px",
    "&.Mui-selected": {
      backgroundColor: "rgba(13,148,136, 0.10) !important",
      color: "#0D9488",
      fontWeight: 600,
    },
    "&:hover": {
      backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)",
    },
  },
  sectorChipDivider: {
    margin: "4px 8px",
    height: 1,
    backgroundColor: theme.palette.divider,
  },
  notifActivateBtn: {
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.82rem",
    padding: "5px 16px",
  },
  notifActiveChip: {
    backgroundColor: "rgba(13,148,136,0.12)",
    color: "#0D9488",
    fontWeight: 700,
    fontSize: "0.78rem",
    borderRadius: 8,
    height: 28,
  },
  notifBlockedChip: {
    backgroundColor: "rgba(229,57,53,0.12)",
    color: "#e53935",
    fontWeight: 700,
    fontSize: "0.78rem",
    borderRadius: 8,
    height: 28,
  },
}));

function TabPanel({ children, value, index, className }) {
  return (
    <div role="tabpanel" className={className} style={{ display: value === index ? "block" : "none" }}>
      {value === index && children}
    </div>
  );
}

// Bloco com titulo e botao Salvar. Fica FORA do componente: definido dentro
// dele, o React remontaria os campos a cada tecla e o cursor sairia do campo.
const SecaoIa = ({ classes, salvando, onSalvar, id, icone, titulo, sub, acao, children }) => (
                <div className={classes.cfgSecao}>
                  <div className={classes.cfgSecaoHead}>
                    <div className={classes.cfgIcone}>{icone}</div>
                    <div style={{ flex: 1, minWidth: 220 }}>
                      <div className={classes.cfgTitulo}>{titulo}</div>
                      <div className={classes.cfgSub}>{sub}</div>
                    </div>
                    {acao}
                  </div>
                  <div className={classes.cfgCorpo}>{children}</div>
                  <div className={classes.cfgRodape}>
                    <span className={classes.cfgRodapeTexto}>As mudanças valem a partir do próximo atendimento.</span>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.cfgBotao}
                      startIcon={<SaveOutlinedIcon />}
                      disabled={salvando === id}
                      onClick={() => onSalvar(id)}
                    >
                      {salvando === id ? "Salvando…" : "Salvar"}
                    </Button>
                  </div>
                </div>
              );

const CAMPOS = [
  "enabled",
  "openaiApiKey",
  "model",
  "modelEffort",
  "systemPrompt",
  "faqContent",
  "assistantName",
  "companyName",
  "website",
  "city",
  "state",
  "slotsOfferedPerTime",
  "minHoursToBook",
  "interviewHourStart",
  "interviewHourEnd",
  "interviewReminderHours",
  "interviewReminderMessage",
  "autoTransferUserIds",
  "noResponseUserId",
  "adminNotificationNumber",
  "flowTimeoutMinutes",
  "iaTimeoutMinutes",
  "maxMessagesBeforeTransfer",
  "maxMinutesBeforeTransfer",
  "responseDelaySeconds",
  "audioToHumanEnabled",
  "audioToHumanMessage",
  "greetingMessage",
  "companyAddress",
  "companyLatitude",
  "companyLongitude",
  "sendLocationAfterBooking",
];

const AIConfig = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const [config, setConfig] = useState(null);
  const [salvando, setSalvando] = useState("");
  const [chaveVisivel, setChaveVisivel] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [enviandoFoto, setEnviandoFoto] = useState(false);
  const [fotoNoEditor, setFotoNoEditor] = useState(null);
  const [buscandoLocal, setBuscandoLocal] = useState(false);
  const [linkMapa, setLinkMapa] = useState("");

  const carregar = async () => {
    try {
      const { data } = await api.get("/ai/config");
      const salvo = String(data?.model || "").trim();
      const modelo = !salvo || APOSENTADOS.test(salvo) ? MODELO_PADRAO : salvo;
      setConfig({
        ...data,
        model: modelo,
        modelEffort: data?.modelEffort || "",
        interviewHourStart: data?.interviewHourStart ?? 8,
        interviewHourEnd: data?.interviewHourEnd ?? 16,
        autoTransferUserIds: Array.isArray(data?.autoTransferUserIds) ? data.autoTransferUserIds : [],
      });
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    carregar();
    api
      .get("/users/")
      .then(({ data }) => setUsuarios(data?.users || []))
      .catch(() => setUsuarios([]));
    // Consumo atualiza sozinho enquanto a tela esta aberta.
    const t = setInterval(async () => {
      try {
        const { data } = await api.get("/ai/config");
        setConfig((c) =>
          c ? { ...c, totalInputTokens: data.totalInputTokens, totalOutputTokens: data.totalOutputTokens } : c
        );
      } catch (e) {
        // segue com o valor antigo
      }
    }, 20000);
    return () => clearInterval(t);
  }, []);

  if (!config) {
    return <div className={classes.root} />;
  }

  const mudar = (campo) => (e) => {
    const valor = e && e.target ? (e.target.type === "checkbox" ? e.target.checked : e.target.value) : e;
    setConfig((c) => ({ ...c, [campo]: valor }));
  };

  const salvar = async (id) => {
    setSalvando(id);
    try {
      const dados = {};
      CAMPOS.forEach((c) => {
        dados[c] = config[c];
      });
      const { data } = await api.put("/ai/config", dados);
      setConfig((c) => ({
        ...c,
        ...data,
        autoTransferUserIds: Array.isArray(data?.autoTransferUserIds) ? data.autoTransferUserIds : c.autoTransferUserIds,
      }));
      toast.success("Configurações salvas.");
    } catch (err) {
      toastError(err);
    } finally {
      setSalvando("");
    }
  };

  const zerarConsumo = async () => {
    try {
      await api.post("/ai/config/zerar-consumo");
      setConfig((c) => ({ ...c, totalInputTokens: 0, totalOutputTokens: 0 }));
      toast.success("Contador de consumo zerado.");
    } catch (err) {
      toastError(err);
    }
  };

  const enviarFoto = async (arquivo) => {
    if (!arquivo) return;
    if (!/^image\/(jpe?g|png|webp)$/i.test(arquivo.type)) {
      toast.error("Escolha uma foto JPG, PNG ou WEBP.");
      return;
    }
    setEnviandoFoto(true);
    try {
      const fd = new FormData();
      fd.append("assistantPhoto", arquivo);
      const { data } = await api.post("/ai/config/assistant-photo", fd);
      setConfig((c) => ({ ...c, assistantPhotoUrl: data.assistantPhotoUrl }));
      toast.success("Foto salva.");
    } catch (err) {
      toastError(err);
    } finally {
      setEnviandoFoto(false);
    }
  };
  const removerFoto = async () => {
    try {
      await api.delete("/ai/config/assistant-photo");
      setConfig((c) => ({ ...c, assistantPhotoUrl: "" }));
    } catch (err) {
      toastError(err);
    }
  };
  const temCoordenadas =
    config.companyLatitude !== null &&
    config.companyLatitude !== undefined &&
    config.companyLatitude !== "" &&
    config.companyLongitude !== null &&
    config.companyLongitude !== undefined &&
    config.companyLongitude !== "";
  const linkGoogle = temCoordenadas
    ? `https://maps.google.com/?q=${Number(config.companyLatitude).toFixed(6)},${Number(config.companyLongitude).toFixed(6)}`
    : config.companyAddress
    ? `https://maps.google.com/?q=${encodeURIComponent(config.companyAddress).replace(/%20/g, "+").replace(/%2C/gi, ",")}`
    : "";
  const mapaEmbed = temCoordenadas
    ? `https://maps.google.com/maps?q=${config.companyLatitude},${config.companyLongitude}&z=17&hl=pt-BR&output=embed`
    : config.companyAddress
    ? `https://maps.google.com/maps?q=${encodeURIComponent(config.companyAddress)}&z=17&hl=pt-BR&output=embed`
    : "";

  // Procura o endereco digitado (OpenStreetMap) e preenche latitude/longitude.
  const buscarEndereco = async () => {
    const q = String(config.companyAddress || "").trim();
    if (!q) {
      toast.info("Digite o endereço completo primeiro.");
      return;
    }
    setBuscandoLocal(true);
    try {
      // Tenta do mais completo ao mais simples (sem "conjunto", "próximo ao..."),
      // no OpenStreetMap e, se não achar, no Photon.
      const COMPL = /\b(conjunto|conj\.?|cj\.?|sala|sl\.?|apto|apartamento|ap\.?|andar|bloco|loja|fundos|pr[oó]ximo|perto|em frente|ao lado|esquina)\b.*$/i;
      const limpo = q.replace(/\s+/g, " ").trim();
      const semCompl = limpo.replace(COMPL, "").replace(/[\s,–-]+$/, "").trim();
      const m = limpo.match(/^(.*?\d+[A-Za-z]?)\b/);
      const base = (m && /[A-Za-zÀ-ú]{3,}/.test(m[1]) ? m[1] : semCompl).replace(/[\s,–-]+$/, "").trim();
      const local = [config.city, config.state].map((v) => String(v || "").trim()).filter(Boolean).join(", ");
      const variantes = [...new Set([limpo, semCompl, local && `${semCompl}, ${local}`, local && `${base}, ${local}`, base, `${base}, Brasil`].filter((v) => v && v.length > 4))];
      const fontes = [
        async (t) => {
          const r = await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=br&accept-language=pt-BR&q=${encodeURIComponent(t)}`);
          const l = await r.json();
          return Array.isArray(l) && l.length ? { lat: parseFloat(l[0].lat), lng: parseFloat(l[0].lon) } : null;
        },
        async (t) => {
          const r = await fetch(`https://photon.komoot.io/api/?limit=1&q=${encodeURIComponent(t)}`);
          const d = await r.json();
          const c = d?.features?.[0]?.geometry?.coordinates;
          return Array.isArray(c) ? { lat: Number(c[1]), lng: Number(c[0]) } : null;
        },
      ];
      let achado = null;
      for (const fonte of fontes) {
        for (const t of variantes) {
          try {
            achado = await fonte(t);
          } catch (e) {
            achado = null;
          }
          if (achado && Number.isFinite(achado.lat)) break;
          achado = null;
        }
        if (achado) break;
      }
      if (!achado) {
        toast.warn("Não achei esse endereço. Confira rua, número e cidade, ou cole o link do Google Maps.");
        return;
      }
      setConfig((c) => ({
        ...c,
        companyLatitude: Number(achado.lat.toFixed(6)),
        companyLongitude: Number(achado.lng.toFixed(6)),
      }));
      toast.success("Endereço encontrado. Confira o pino no mapa e salve.");
    } catch (e) {
      toast.error("Não consegui buscar agora. Cole o link do Google Maps.");
    } finally {
      setBuscandoLocal(false);
    }
  };

  const usarLinkMapa = (texto) => {
    setLinkMapa(texto);
    const c = coordenadasDoLink(texto);
    if (c) {
      setConfig((cfg) => ({ ...cfg, companyLatitude: c.lat, companyLongitude: c.lng }));
      toast.success("Localização lida do link. Confira o pino e salve.");
    } else if (/goo\.gl|maps\.app/i.test(texto)) {
      toast.info("Link curto: abra ele no navegador e cole aqui o endereço completo que aparecer na barra.");
    }
  };

  const trocarVariaveis = (texto) =>
    String(texto || "")
      .replace(/\{\{\s*name\s*\}\}/gi, "Marina")
      .replace(/\{\{\s*assistente\s*\}\}/gi, config.assistantName || "assistente")
      .replace(/\{\{\s*empresa\s*\}\}/gi, config.companyName || "empresa");

  const modeloAtual = MODELOS_OPENAI.find((m) => m.id === config.model);
  const [familiaEscolhida, setFamiliaEscolhida] = [
    modeloAtual ? modeloAtual.familia : "outro",
    (fam) => {
      const f = FAMILIAS.find((x) => x.id === fam);
      setConfig((c) => ({
        ...c,
        model: f && f.versoes.length ? f.versoes[0].id : "",
        modelEffort: "",
      }));
    },
  ];
  const familia = FAMILIAS.find((f) => f.id === familiaEscolhida);
  const esforcosDoModelo = modeloAtual
    ? modeloAtual.esforcos
    : ehRaciocinio(config.model)
    ? ["none", "low", "medium", "high"]
    : [];
  const esforcoPadrao = modeloAtual ? modeloAtual.padrao : "low";
  const esforcoValido = esforcosDoModelo.includes(config.modelEffort) ? config.modelEffort : "";
  const esforcoEfetivo = esforcoValido || esforcoPadrao;
  const custo = modeloAtual
    ? ((config.totalInputTokens || 0) / 1e6) * modeloAtual.entrada +
      ((config.totalOutputTokens || 0) / 1e6) * modeloAtual.saida
    : null;
  const semChave = !String(config.openaiApiKey || "").trim();

  const numero = (campo, rotulo, ajuda, extra = {}) => (
    <TextField
      label={rotulo}
      type="number"
      variant="outlined"
      size="small"
      fullWidth
      helperText={ajuda}
      value={config[campo] ?? ""}
      onChange={mudar(campo)}
      inputProps={{ min: 0, ...extra }}
    />
  );

  return (
    <div className={classes.root}>
      <EditorDeImagem
        open={!!fotoNoEditor}
        arquivo={fotoNoEditor}
        onCancel={() => setFotoNoEditor(null)}
        onConfirmar={(f) => {
          setFotoNoEditor(null);
          enviarFoto(f);
        }}
      />
      <Container maxWidth="xl" className={classes.mainContainer}>
        <Paper className={classes.paper}>
          <div className={classes.banner}>
            <div className={classes.bannerTopo}>
              <div>
                <div className={classes.bannerTitulo}>
                  <span className={classes.bannerIcone}>
                    <MemoryOutlinedIcon />
                  </span>
                  Assistente de RH
                </div>
                <div className={classes.bannerSub}>
                  Recrutadora virtual com OpenAI (GPT-6): atende candidatos, faz a triagem e agenda entrevistas na Agenda.
                </div>
              </div>
              <span
                className={classes.bannerPill}
                style={
                  config.enabled
                    ? { color: "#ffffff", background: "rgba(255,255,255,0.18)" }
                    : { color: "#e2e8f0", background: "rgba(0,0,0,0.16)" }
                }
              >
                <span
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: config.enabled ? "#5eead4" : "#cbd5e1",
                    animation: config.enabled ? "sbPontoVivo 2s ease-in-out infinite" : "none",
                  }}
                />
                IA {config.enabled ? "ligada" : "desligada"}
              </span>
            </div>
            <Tabs
              value={tab}
              onChange={(e, v) => setTab(v)}
              className={classes.tabs}
              variant="scrollable"
              scrollButtons="off"
            >
              <Tab icon={<TuneRoundedIcon />} label="Conexão com a IA" />
              <Tab icon={<ForumOutlinedIcon />} label="Comportamento" />
              <Tab icon={<EventOutlinedIcon />} label="Agenda e transferência" />
            </Tabs>
          </div>

          {/* ================= CONEXAO ================= */}
          <TabPanel value={tab} index={0} className={classes.tabPanel}>
            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="conexao"
              icone={<VpnKeyOutlinedIcon />}
              titulo="Conexões e modelo"
              sub="Liga a assistente, escolhe o modelo e guarda a chave de acesso."
              acao={
                <span className={`${classes.cfgPill} ${config.enabled ? classes.cfgPillOn : classes.cfgPillOff}`}>
                  <span className={classes.cfgPonto} /> IA {config.enabled ? "ligada" : "desligada"}
                </span>
              }
            >
              <div className={classes.cfgGrid}>
                {/* ---------- assistente + modelo ---------- */}
                <div className={classes.cfgBloco}>
                  <div className={classes.cfgBlocoTitulo}>
                    <PowerSettingsNewIcon /> Assistente
                  </div>
                  <div className={classes.cfgSwitchLinha}>
                    <span>{config.enabled ? "Atendendo os candidatos" : "Desligada para todos"}</span>
                    <Switch checked={!!config.enabled} onChange={mudar("enabled")} color="primary" />
                  </div>
                  {config.enabled && semChave && (
                    <div className={classes.cfgResumo} style={{ marginBottom: 0 }}>
                      Sem a chave da OpenAI a assistente não responde. Cole a chave ao lado e salve.
                    </div>
                  )}

                  <div className={classes.mdGrade}>
                    {FAMILIAS.map((f) => {
                      const ativo = f.id === familiaEscolhida;
                      return (
                        <button
                          type="button"
                          key={f.id}
                          className={`${classes.mdCartao} ${ativo ? classes.mdCartaoAtivo : ""}`}
                          onClick={() => !ativo && setFamiliaEscolhida(f.id)}
                        >
                          <span className={classes.mdNome}>
                            {f.nome}
                            {f.recomendado && <span className={classes.mdSelo}>Recomendado</span>}
                          </span>
                          <span className={classes.mdDesc}>{f.desc}</span>
                          <span className={classes.mdPreco}>{f.preco}</span>
                          {ativo && (
                            <span className={classes.mdCheck}>
                              <CheckRoundedIcon />
                            </span>
                          )}
                        </button>
                      );
                    })}
                  </div>

                  <div className={classes.cfgLinha2}>
                    <FormControl variant="outlined" size="small" fullWidth className={classes.selectCompacto}>
                      <InputLabel id="versao-openai">Versão</InputLabel>
                      <Select
                        labelId="versao-openai"
                        label="Versão"
                        value={modeloAtual ? config.model : "__digitar"}
                        onChange={(e) => {
                          const v = e.target.value;
                          setConfig((c) => ({ ...c, model: v === "__digitar" ? "" : v, modelEffort: "" }));
                        }}
                      >
                        {(familia ? familia.versoes : []).map((v) => (
                          <MenuItem key={v.id} value={v.id}>
                            <ListItemText
                              primary={v.nome}
                              secondary={`${usd(v.entrada)} / ${usd(v.saida)} por milhão de tokens`}
                            />
                          </MenuItem>
                        ))}
                        {familiaEscolhida === "outro" && (
                          <MenuItem value="__digitar">
                            <ListItemText primary="Digitar outro nome…" secondary="Qualquer modelo da sua conta OpenAI" />
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    <FormControl variant="outlined" size="small" fullWidth disabled={!esforcosDoModelo.length} className={classes.selectCompacto}>
                      <InputLabel id="esforco-openai">Esforço</InputLabel>
                      <Select
                        labelId="esforco-openai"
                        label="Esforço"
                        value={!esforcosDoModelo.length ? "__na" : esforcoValido || "__padrao"}
                        onChange={(e) => {
                          const v = e.target.value;
                          setConfig((c) => ({ ...c, modelEffort: v === "__padrao" ? "" : v }));
                        }}
                      >
                        {!esforcosDoModelo.length && <MenuItem value="__na">Não se aplica</MenuItem>}
                        {esforcosDoModelo.length > 0 && (
                          <MenuItem value="__padrao">Padrão do modelo ({NOMES_ESFORCO[esforcoPadrao]})</MenuItem>
                        )}
                        {esforcosDoModelo.map((e) => (
                          <MenuItem key={e} value={e}>
                            <ListItemText primary={NOMES_ESFORCO[e]} secondary={DESC_ESFORCO[e]} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  {!modeloAtual && (
                    <TextField
                      label="Nome do modelo"
                      placeholder="Ex.: gpt-6-luna"
                      variant="outlined"
                      size="small"
                      fullWidth
                      autoFocus
                      value={config.model || ""}
                      onChange={mudar("model")}
                      helperText="Use o nome exato que aparece na sua conta OpenAI. O preço não é calculado para modelos digitados."
                    />
                  )}

                  <div className={classes.mdTiles}>
                    <div className={classes.mdTile}>
                      <span className={classes.mdTileRotulo}>Entrada</span>
                      <span className={classes.mdTileValor}>{modeloAtual ? usd(modeloAtual.entrada) : "—"}</span>
                      <span className={classes.mdTileSub}>por milhão de tokens</span>
                    </div>
                    <div className={classes.mdTile}>
                      <span className={classes.mdTileRotulo}>Saída</span>
                      <span className={classes.mdTileValor}>{modeloAtual ? usd(modeloAtual.saida) : "—"}</span>
                      <span className={classes.mdTileSub}>por milhão de tokens</span>
                    </div>
                    <div className={classes.mdTile}>
                      <span className={classes.mdTileRotulo}>Esforço</span>
                      <span className={classes.mdTileValor}>
                        {esforcosDoModelo.length ? NOMES_ESFORCO[esforcoEfetivo] : "—"}
                      </span>
                      <span className={classes.mdTileSub}>
                        {!esforcosDoModelo.length ? "não se aplica" : esforcoValido ? "escolhido" : "padrão do modelo"}
                      </span>
                    </div>
                  </div>
                </div>

                {/* ---------- chave + consumo ---------- */}
                <div className={classes.cfgColuna}>
                  <div className={classes.cfgBloco}>
                    <div className={classes.cfgBlocoTitulo}>
                      <VpnKeyOutlinedIcon /> Chave de API
                    </div>
                    <TextField
                      label="OpenAI"
                      placeholder="sk-..."
                      variant="outlined"
                      size="small"
                      fullWidth
                      value={config.openaiApiKey || ""}
                      onChange={mudar("openaiApiKey")}
                      helperText={
                        semChave
                          ? "Crie em platform.openai.com › Chaves de API"
                          : "Chave cadastrada · também transcreve áudios e lê imagens"
                      }
                      inputProps={campoSecreto(chaveVisivel)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton size="small" edge="end" onClick={() => setChaveVisivel((v) => !v)}>
                              {chaveVisivel ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className={classes.cfgBloco}>
                    <div className={classes.cfgBlocoTitulo}>
                      <MemoryOutlinedIcon /> Consumo
                    </div>
                    <div className={classes.cfgSwitchLinha}>
                      <span>Tokens de entrada</span>
                      <b>{(config.totalInputTokens || 0).toLocaleString("pt-BR")}</b>
                    </div>
                    <div className={classes.cfgSwitchLinha}>
                      <span>Tokens de saída</span>
                      <b>{(config.totalOutputTokens || 0).toLocaleString("pt-BR")}</b>
                    </div>
                    {custo !== null && (
                      <div className={classes.cfgSwitchLinha}>
                        <span>Custo estimado</span>
                        <b>{usd(custo.toFixed(2))}</b>
                      </div>
                    )}
                    <Button variant="outlined" size="small" onClick={zerarConsumo}>
                      Zerar contador
                    </Button>
                  </div>
                </div>
              </div>
            </SecaoIa>
          </TabPanel>

          {/* ================= COMPORTAMENTO ================= */}
          <TabPanel value={tab} index={1} className={classes.tabPanel}>
            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="empresa"
              icone={<BusinessOutlinedIcon />}
              titulo="Identidade"
              sub="Como a assistente se apresenta e de qual empresa ela fala."
            >
              <div className={classes.iaGrid4}>
                <TextField
                  label="Nome da assistente"
                  placeholder="Ex.: Ana"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={config.assistantName || ""}
                  onChange={mudar("assistantName")}
                />
                <TextField
                  label="Nome da empresa"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={config.companyName || ""}
                  onChange={mudar("companyName")}
                />
                <TextField
                  label="Cidade"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={config.city || ""}
                  onChange={mudar("city")}
                />
                <TextField
                  label="Estado"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={config.state || ""}
                  onChange={mudar("state")}
                />
                <TextField
                  label="Site"
                  variant="outlined"
                  size="small"
                  fullWidth
                  className={classes.iaSpan2}
                  value={config.website || ""}
                  onChange={mudar("website")}
                />
              </div>
            </SecaoIa>

            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="localizacao"
              icone={<RoomOutlinedIcon />}
              titulo="Localização da empresa"
              sub="A assistente manda o pino com mini mapa no WhatsApp e o link do Google Maps para o candidato."
              acao={
                <span className={`${classes.cfgPill} ${temCoordenadas ? classes.cfgPillOn : classes.cfgPillOff}`}>
                  <span className={classes.cfgPonto} /> {temCoordenadas ? "Pino definido" : "Sem pino no mapa"}
                </span>
              }
            >
              <div className={classes.pvGrid}>
                <div>
                  <TextField
                    label="Endereço completo"
                    placeholder="Rua, número, bairro, cidade - UF"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={config.companyAddress || ""}
                    onChange={mudar("companyAddress")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        buscarEndereco();
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Button size="small" startIcon={<SearchIcon />} onClick={buscarEndereco} disabled={buscandoLocal}>
                            {buscandoLocal ? "Buscando…" : "Achar no mapa"}
                          </Button>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextField
                    label="…ou cole o link do Google Maps"
                    placeholder="https://www.google.com/maps/place/…"
                    variant="outlined"
                    size="small"
                    fullWidth
                    value={linkMapa}
                    onChange={(e) => usarLinkMapa(e.target.value)}
                    helperText="No Google Maps: procure a empresa, clique em Compartilhar › Copiar link (ou copie a barra de endereço)."
                    style={{ marginTop: 14 }}
                  />
                  <div className={classes.cfgLinha2} style={{ marginTop: 14 }}>
                    <TextField
                      label="Latitude"
                      variant="outlined"
                      size="small"
                      value={config.companyLatitude ?? ""}
                      onChange={(e) => setConfig((c) => ({ ...c, companyLatitude: e.target.value.replace(",", ".") }))}
                    />
                    <TextField
                      label="Longitude"
                      variant="outlined"
                      size="small"
                      value={config.companyLongitude ?? ""}
                      onChange={(e) => setConfig((c) => ({ ...c, companyLongitude: e.target.value.replace(",", ".") }))}
                    />
                  </div>
                  <div className={classes.cfgSwitchLinha} style={{ marginTop: 14 }}>
                    <span>Mandar a localização junto com a confirmação da entrevista</span>
                    <Switch
                      checked={config.sendLocationAfterBooking !== false}
                      onChange={mudar("sendLocationAfterBooking")}
                      color="primary"
                    />
                  </div>
                  <div className={classes.ajuda}>
                    A assistente também manda a localização sempre que o candidato perguntar onde fica. Nos Fluxos
                    Visuais existe o bloco <b>Localização</b> para mandar em qualquer etapa.
                  </div>
                </div>

                <PreviaWhats
                  classes={classes}
                  titulo={config.assistantName || "Assistente de RH"}
                  sub="Prévia — localização no WhatsApp"
                >
                  {mapaEmbed ? (
                    <>
                      <div className={`${classes.pvBalao} ${classes.pvBalaoEu}`} style={{ padding: 4, width: "88%" }}>
                        <iframe
                          title="Mapa da empresa"
                          src={mapaEmbed}
                          className={classes.mapaMini}
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        />
                        <span style={{ fontWeight: 800 }}>{config.companyName || "Nossa empresa"}</span>
                        {config.companyAddress && <span style={{ fontSize: "0.78rem", opacity: 0.8 }}>{config.companyAddress}</span>}
                      </div>
                      <div className={`${classes.pvBalao} ${classes.pvBalaoEu}`}>
                        <span>
                          📍 <b>{config.companyName || "Nossa empresa"}</b>
                          {config.companyAddress ? `\n${config.companyAddress}` : ""}
                          {"\n🗺️ "}
                          <a href={linkGoogle} target="_blank" rel="noopener noreferrer" style={{ color: "#027eb5", wordBreak: "break-all" }}>
                            {linkGoogle}
                          </a>
                        </span>
                      </div>
                    </>
                  ) : (
                    <div className={classes.ajuda}>Digite o endereço ou cole o link do Google Maps para ver o mapa.</div>
                  )}
                </PreviaWhats>
              </div>
            </SecaoIa>

            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="abertura"
              icone={<ChatOutlinedIcon />}
              titulo="Mensagem de abertura"
              sub="Primeira mensagem que a assistente manda quando assume a conversa com o candidato."
              acao={
                !config.greetingMessage ? (
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() =>
                      setConfig((c) => ({
                        ...c,
                        greetingMessage: ABERTURA_SUGERIDA.replace("{{assistente}}", c.assistantName || "assistente").replace(
                          "{{empresa}}",
                          c.companyName || "nossa empresa"
                        ),
                      }))
                    }
                  >
                    Usar texto sugerido
                  </Button>
                ) : null
              }
            >
              <div className={classes.pvGrid}>
                <div>
                  <TextField
                    label="Texto da mensagem"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                    placeholder="Em branco, a assistente não manda abertura e já responde direto."
                    value={config.greetingMessage || ""}
                    onChange={mudar("greetingMessage")}
                    helperText="Use {{name}} para o nome do candidato."
                  />
                  <div className={classes.fotoLinha}>
                    {config.assistantPhotoUrl ? (
                      <img src={urlPublica(config.assistantPhotoUrl)} alt="" className={classes.fotoMini} />
                    ) : (
                      <span className={classes.fotoVazia}>
                        <PhotoCameraOutlinedIcon />
                      </span>
                    )}
                    <Button
                      size="small"
                      variant="outlined"
                      component="label"
                      startIcon={<PhotoCameraOutlinedIcon />}
                      disabled={enviandoFoto}
                    >
                      {enviandoFoto ? "Enviando…" : config.assistantPhotoUrl ? "Trocar foto" : "Adicionar foto"}
                      <input
                        type="file"
                        hidden
                        accept="image/jpeg,image/png,image/webp"
                        onChange={(e) => {
                          const f = e.target.files && e.target.files[0];
                          if (f) setFotoNoEditor(f);
                          e.target.value = "";
                        }}
                      />
                    </Button>
                    {config.assistantPhotoUrl && (
                      <Button size="small" startIcon={<DeleteOutlineIcon />} onClick={removerFoto}>
                        Remover
                      </Button>
                    )}
                  </div>
                  <div className={classes.ajuda}>
                    Opcional. A foto vai junto com a abertura, com o texto como legenda. Ela é salva na hora (não
                    precisa clicar em Salvar); o texto precisa de Salvar.
                  </div>
                </div>
                <PreviaWhats
                  classes={classes}
                  titulo={config.assistantName || "Assistente de RH"}
                  sub="Prévia — mensagem de abertura"
                >
                  {config.greetingMessage || config.assistantPhotoUrl ? (
                    <div className={classes.pvBalao}>
                      {config.assistantPhotoUrl && <img src={urlPublica(config.assistantPhotoUrl)} alt="" />}
                      {config.greetingMessage && <span>{trocarVariaveis(config.greetingMessage)}</span>}
                    </div>
                  ) : (
                    <div className={classes.ajuda}>Sem abertura: a assistente responde direto à mensagem do candidato.</div>
                  )}
                </PreviaWhats>
              </div>
            </SecaoIa>

            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="prompt"
              icone={<ForumOutlinedIcon />}
              titulo="Roteiro da assistente (prompt)"
              sub="Como ela conversa e conduz a triagem. As regras de agendamento são adicionadas automaticamente."
              acao={
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    if (
                      String(config.systemPrompt || "").trim() &&
                      !window.confirm("Trocar o roteiro atual pelo roteiro sugerido (currículo, requisito da vaga e horários)?")
                    )
                      return;
                    setConfig((c) => ({ ...c, systemPrompt: ROTEIRO_SUGERIDO }));
                  }}
                >
                  Usar roteiro sugerido
                </Button>
              }
            >
              <TextField
                className={classes.cfgPrompt}
                variant="outlined"
                fullWidth
                multiline
                rows={14}
                placeholder={`Em branco, ela usa o roteiro padrão:\n\n${ROTEIRO_SUGERIDO}`}
                value={config.systemPrompt || ""}
                onChange={mudar("systemPrompt")}
              />
              <div className={classes.cfgSub} style={{ marginTop: 6 }}>
                {(config.systemPrompt || "").length.toLocaleString("pt-BR")} caracteres
              </div>
            </SecaoIa>

            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="base"
              icone={<MenuBookOutlinedIcon />}
              titulo="Base de conhecimento: vagas e informações"
              sub="Tudo o que a assistente pode responder: vagas, requisitos, salário, benefícios, endereço, o que levar na entrevista."
              acao={
                true ? (
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      if (
                        String(config.faqContent || "").trim() &&
                        !window.confirm("Trocar a base de conhecimento atual pelo modelo de vagas?")
                      )
                        return;
                      setConfig((c) => ({ ...c, faqContent: EXEMPLO_BASE }));
                    }}
                  >
                    Preencher com o modelo de vagas
                  </Button>
                ) : null
              }
            >
              <TextField
                className={classes.cfgPrompt}
                variant="outlined"
                fullWidth
                multiline
                rows={14}
                placeholder={EXEMPLO_BASE}
                value={config.faqContent || ""}
                onChange={mudar("faqContent")}
              />
            </SecaoIa>
          
            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="audio"
              icone={<MicNoneOutlinedIcon />}
              titulo="Áudio do candidato"
              sub="A OpenAI transcreve o áudio e a assistente responde como se fosse texto."
              acao={
                <span className={`${classes.cfgPill} ${semChave ? classes.cfgPillWarn : classes.cfgPillOn}`}>
                  <span className={classes.cfgPonto} /> {semChave ? "Sem chave da OpenAI" : "Transcrição ligada"}
                </span>
              }
            >
              <div className={classes.pvGrid}>
                <div>
                  <div className={classes.ajuda} style={{ marginTop: 0, marginBottom: 14 }}>
                    Usa a mesma chave da aba <b>Conexão com a IA</b> (modelo <b>gpt-transcribe</b>, cerca de US$ 0,0045 por
                    minuto de áudio). Se o candidato estiver com uma pessoa do RH, o áudio aparece na hora e a transcrição chega
                    logo depois.
                  </div>
                  <div className={classes.cfgSwitchLinha}>
                    <span>Se não der para entender o áudio, passar para uma pessoa</span>
                    <Switch
                      checked={config.audioToHumanEnabled !== false}
                      onChange={mudar("audioToHumanEnabled")}
                      color="primary"
                    />
                  </div>
                  <TextField
                    label="Mensagem para o candidato"
                    multiline
                    rows={3}
                    variant="outlined"
                    fullWidth
                    disabled={config.audioToHumanEnabled === false}
                    placeholder={AVISO_AUDIO_PADRAO}
                    value={config.audioToHumanMessage || ""}
                    onChange={mudar("audioToHumanMessage")}
                    helperText="Em branco, usa o texto de exemplo."
                    style={{ marginTop: 14 }}
                  />
                </div>
                <PreviaWhats
                  classes={classes}
                  titulo={config.assistantName || "Assistente de RH"}
                  sub="Prévia — áudio que não deu para entender"
                >
                  <div className={`${classes.pvBalao} ${classes.pvAudio}`}>
                    <PlayArrowRoundedIcon />
                    <span className={classes.pvOnda} />
                    0:12
                  </div>
                  {config.audioToHumanEnabled !== false ? (
                    <div className={`${classes.pvBalao} ${classes.pvBalaoEu}`}>
                      <span>{config.audioToHumanMessage || AVISO_AUDIO_PADRAO}</span>
                    </div>
                  ) : (
                    <div className={classes.ajuda}>Desligado: a assistente pede para o candidato escrever.</div>
                  )}
                </PreviaWhats>
              </div>
            </SecaoIa>
          </TabPanel>

          {/* ================= AGENDA E TRANSFERENCIA ================= */}
          <TabPanel value={tab} index={2} className={classes.tabPanel}>
            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="agenda"
              icone={<EventOutlinedIcon />}
              titulo="Agendamento de entrevistas"
              sub="Como a assistente oferece os horários cadastrados na Agenda."
            >
              <div className={classes.iaGrid3}>
                {numero("slotsOfferedPerTime", "Dias oferecidos por vez", "Quantos dias ela mostra primeiro (1 a 8). Depois que o candidato escolhe o dia, ela mostra todos os horários livres dele.", {
                  max: 8,
                  min: 1,
                })}
                {numero("minHoursToBook", "Antecedência mínima (horas)", "Não oferece horários mais próximos que isso.")}
                {numero("interviewReminderHours", "Lembrete antes (horas)", "0 desliga o lembrete automático.")}
                {numero("interviewHourStart", "Entrevistas a partir de (hora)", "Ex.: 8 = não oferece antes das 8h.", { max: 23 })}
                {numero("interviewHourEnd", "Entrevistas até (hora)", "Ex.: 16 = último horário começa antes das 16h.", { max: 24 })}
              </div>
              <TextField
                label="Mensagem de lembrete"
                variant="outlined"
                fullWidth
                multiline
                rows={4}
                style={{ marginTop: 16 }}
                placeholder={LEMBRETE_PADRAO}
                helperText="Variáveis: {{nome}}, {{quando}}, {{data}}, {{hora}}, {{vaga}}, {{local}}. Em branco usa o texto padrão."
                value={config.interviewReminderMessage || ""}
                onChange={mudar("interviewReminderMessage")}
              />
            </SecaoIa>

            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="transferencia"
              icone={<SwapHorizOutlinedIcon />}
              titulo="Passagem para o RH"
              sub="Quando o candidato pede uma pessoa ou a assistente não sabe resolver."
            >
              <div className={classes.iaGrid2}>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel id="recrutadores" shrink>Recrutadores que recebem automaticamente</InputLabel>
                  <Select
                    labelId="recrutadores"
                    label="Recrutadores que recebem automaticamente"
                    multiple
                    displayEmpty
                    notched
                    value={config.autoTransferUserIds || []}
                    onChange={(e) => {
                      const valor = e.target.value;
                      setConfig((c) => ({ ...c, autoTransferUserIds: valor }));
                    }}
                    renderValue={(ids) =>
                      ids.length ? (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                          {ids.map((id) => (
                            <Chip key={id} size="small" label={usuarios.find((u) => u.id === id)?.name || id} />
                          ))}
                        </div>
                      ) : (
                        "Todos os admins (rodízio)"
                      )
                    }
                  >
                    {usuarios
                      .map((u) => (
                        <MenuItem key={u.id} value={u.id}>
                          <Checkbox
                            color="primary"
                            size="small"
                            checked={(config.autoTransferUserIds || []).includes(u.id)}
                          />
                          <ListItemText primary={u.name} />
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel id="semResposta" shrink>Quem recebe os candidatos que não responderam</InputLabel>
                  <Select
                    labelId="semResposta"
                    label="Quem recebe os candidatos que não responderam"
                    value={config.noResponseUserId || ""}
                    displayEmpty
                    notched
                    onChange={(e) => {
                      const valor = e.target.value;
                      setConfig((c) => ({ ...c, noResponseUserId: valor === "" ? null : valor }));
                    }}
                    renderValue={(id) =>
                      id ? usuarios.find((u) => u.id === id)?.name || id : "Automático (rodízio entre a equipe)"
                    }
                  >
                    <MenuItem value="">
                      <ListItemText primary="Automático (rodízio entre a equipe)" />
                    </MenuItem>
                    {usuarios
                      .filter((u) => u.profile === "admin" || u.profile === "operador")
                      .map((u) => (
                        <MenuItem key={u.id} value={u.id}>
                          <ListItemText primary={u.name} />
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText>
                    Quando o candidato para de responder (no fluxo ou com a assistente), vai sempre para este admin.
                  </FormHelperText>
                </FormControl>
                <TextField
                  label="WhatsApp do administrador (alertas)"
                  placeholder="(11) 99999-8888"
                  variant="outlined"
                  size="small"
                  fullWidth
                  helperText="Recebe aviso quando a assistente transfere ou para por falha."
                  value={mascaraTelefone(config.adminNotificationNumber)}
                  onChange={(e) => {
                    const numero = soDigitosTelefone(e.target.value);
                    setConfig((c) => ({ ...c, adminNotificationNumber: numero }));
                  }}
                  inputProps={{ inputMode: "tel", maxLength: 16 }}
                />
              </div>
            </SecaoIa>

            <SecaoIa
              classes={classes}
              salvando={salvando}
              onSalvar={salvar}
              id="tempos"
              icone={<TimerOutlinedIcon />}
              titulo="Tempos e limites"
              sub="0 desliga cada limite."
            >
              <div className={classes.iaGrid3}>
                {numero(
                  "responseDelaySeconds",
                  "Esperar antes de responder (s)",
                  "Junta mensagens picadas do candidato (2 a 30).",
                  { max: 30 }
                )}
                {numero("flowTimeoutMinutes", "Silêncio no fluxo visual (min)", "Depois disso o atendimento vai para o RH.")}
                {numero("iaTimeoutMinutes", "Silêncio com a assistente (min)", "Candidato parou de responder na triagem.")}
                {numero("maxMessagesBeforeTransfer", "Máx. de mensagens com a IA", "Evita conversa em círculo.")}
                {numero("maxMinutesBeforeTransfer", "Máx. de minutos com a IA", "Duração máxima de uma conversa.")}
              </div>
            </SecaoIa>
          </TabPanel>
        </Paper>
      </Container>
    </div>
  );
};

export default AIConfig;
